<div class="flex flex-col gap-4">
  <div class="flex items-start gap-4">
    <div class="flex flex-col gap-4 h-full justify-start flex-1 min-w-0">
      <div class="flex items-center gap-4">
        <div class="bg-white rounded-lg">
          <p-button [label]="'Back'"
                    [severity]="'secondary'"
                    [outlined]="true"
                    [icon]="'fa fa-chevron-left'"
                    (onClick)="goBack()"
          ></p-button>
        </div>

        <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">
          {{ 'Travel Allowance Cancellation Approval for ' + taSubmission()?.taNumber }}
        </div>

        <div class="flex gap-1 items-center">
          @if (travellersLength() > 1) {
            <i class="fa-solid fa-users"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name + ' (+' + (taSubmission()!.travellerCount! - 1) + ')'}}</div>
          } @else {
            <i class="fa-solid fa-user"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name}}</div>
          }
        </div>
      </div>

      <div class="justify-start text-text-color text-sm font-semibold font-['Inter'] leading-4">{{'Travel Date: ' + ((taSubmission()?.startDate | date: 'dd/MM/yy') ?? '-') }}</div>

      <div class="w-full lg:w-2/3 justify-start">
        <div class="text-text-color text-sm font-normal font-['Inter'] leading-5">
          This is a prepaid TA whose <span class="font-bold">prepayment has already been processed.</span>
        </div>
        <div class="text-text-color text-sm font-normal font-['Inter'] leading-5">
          This TA is pending <span class="font-bold">cancellation</span> acknowledgement.
        </div>
      </div>

      @if (cancelApprovalRole() === 'primaryApprover') {
        <div class="w-full lg:w-2/3 justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
          Please acknowledge the cancellation of this travel allowance. Once acknowledged the TA value drops
          to $0 and the prepayment already made to the traveller will be recovered.
        </div>
      }
      <!-- A view only user is told who the TA is waiting on by the approvals table below. -->

      <ta-approvals-table [taSubmission]="taSubmission()"
                          [contexts]="cancellationContexts"
                          [editable]="true"
                          heading="Required Cancellation Approvals"
      ></ta-approvals-table>
    </div>

    <div class="flex flex-col gap-2 items-end">
      <!-- The TA is still worth what it was worth. It is zeroed, and any prepayment becomes
           recoverable, once this cancellation is approved. -->
      <ta-cost-bubble title="Approved TA Value" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
      @if (isPrePaid()) {
        <div class="w-full h-[1px] bg-surface-200"></div>
        <ta-cost-bubble title="Prepayment Component" titleIcon="fa-regular fa-piggy-bank text-green-700" [value]="prepaymentComponent()" severity="success"></ta-cost-bubble>
      }
    </div>
  </div>

  @if (cancelApprovalRole() === 'primaryApprover' || canRevertCancellation()) {
    <div class="w-full h-[1px] bg-surface-200"></div>
    <div class="flex gap-10 pt-4">
      <div class="flex flex-col gap-4">
        @if (cancelApprovalRole() === 'primaryApprover') {
          <p-button [severity]="'primary'" styleClass="w-64" (onClick)="confirmApproveTaCancellation()">
            <i class="pi pi-check-circle pl-[1px]"></i>
            <span class="flex-1">Acknowledge Cancellation</span>
          </p-button>
        }
        @if (canRevertCancellation()) {
          <div class="bg-white rounded-lg">
            <p-button [severity]="'secondary'" outlined styleClass="w-64" (onClick)="confirmReverseCancellation()">
              <i class="pi pi-exclamation-circle pl-[1px] text-surface-700"></i>
              <span class="flex-1">Reverse Cancellation</span>
            </p-button>
          </div>
        }
      </div>
    </div>
  }
</div>
